// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uf-0";
export var checkoutRateBadgeLink = "_uf-1";